module.exports = __webpack_public_path__ + "static/media/twitter.a8d8a0d2.svg";